import { extractErrorMessage } from "@/lib/error"

import { channelConversationService } from "../services/channel-conversation-service"

/**
 * Action to mark a conversation as closed
 * @param conversationId - The ID of the conversation to mark as closed
 * @throws Error if the operation fails
 */
export async function markConversationAsClosed(conversationId: string): Promise<void> {
  try {
    await channelConversationService.updateConversationStatus(conversationId, "closed")
  } catch (error) {
    const errorMessage = extractErrorMessage(error, "Falha ao marcar conversa como resolvida")
    throw new Error(errorMessage)
  }
}

/**
 * Action to bulk close all active/waiting conversations
 * @returns The number of conversations closed
 * @throws Error if the operation fails
 */
export async function bulkCloseAllConversations(): Promise<number> {
  try {
    const result = await channelConversationService.bulkCloseConversations()
    return result.closed_count
  } catch (error) {
    const errorMessage = extractErrorMessage(error, "Falha ao concluir todas as conversas")
    throw new Error(errorMessage)
  }
}

/**
 * Action to update conversation status
 * @param conversationId - The ID of the conversation
 * @param status - The new status for the conversation
 * @throws Error if the operation fails
 */
export async function updateConversationStatus(
  conversationId: string,
  status: "active" | "closed" | "waiting"
): Promise<void> {
  try {
    await channelConversationService.updateConversationStatus(conversationId, status)
  } catch (error) {
    const errorMessage = extractErrorMessage(error, "Falha ao atualizar status da conversa")
    throw new Error(errorMessage)
  }
}
